<template>
    <v-dialog v-model="showAlert" class="session-timeout-alert">
        Your session is expire. Log In.
    </v-dialog>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            sessionLifetime: null,
            showAlert: false,
        };
    },
    mounted() {
        //this.getSessionLifetime();
    },
    methods: {
        // getSessionLifetime() {
        //     axios
        //         .get("/api/session-lifetime")
        //         .then((response) => {
        //             this.sessionLifetime = response.data.sessionLifetime;
        //             this.startSessionTimeout();
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //         });
        // },
        // startSessionTimeout() {
        //     const timeout = this.sessionLifetime * 60 * 1000; // Convert minutes to milliseconds
        //
        //     setTimeout(() => {
        //         //  alert("Your session has expired. Please log in again.");
        //         //this.showAlert = true;
        //
        //         window.location.href = route("login");
        //     }, timeout);
        // },
    },
};
</script>

<style>
.session-timeout-alert {
    position: fixed;
    top: 10px;
    left: 10px;
    padding: 10px;
    background-color: yellow;
    font-weight: bold;
}
</style>
